<template>
  <div id="widget-commerce" :class="{ 'is-open': isOpen, 'pointer-none': !preview }" :style="cssVars">
    <div class="position-relative" v-if="!hideWidget">
      <div class="menu-wrapper" :class="{ 'is-open': isOpen }">
        <a class="wgdcom-item" v-if="shopSettings.isOpenCart">
          <div class="wgdcom-icon"><i class="fa fa-shopping-cart"></i></div>
          <div class="wgdcom-text">{{$t('website.pageProduct.lblCart', languageUse)}}</div>
        </a>
        <a class="wgdcom-item" v-if="shopSettings.isOpenCompareProduct">
          <div class="wgdcom-icon"><i class="fa fa-exchange fa-2x">&nbsp;</i></div>
          <div class="wgdcom-text">{{$t('website.pageProduct.lblCompare', languageUse)}}</div>
        </a>
        <a class="wgdcom-item" v-if="shopSettings.isOpenWishlist">
          <div class="wgdcom-icon"><i class="far fa-heart fa-2x">&nbsp;</i></div>
          <div class="wgdcom-text">{{$t('website.pageProduct.lblWishlist', languageUse)}}</div>
        </a>
      </div>
      <div class="wgdcom-btn" :class="`theme-${theme}`" @click="toggleWidget">
        <i class="fa fa-shopping-cart icon-cart"></i>
        <i class="fa fa-times icon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      appearance: "designIframe/metadata/appearance",
      shopSettings: "designIframe/page/shopSettings",
      languageUse: "designIframe/metadata/siteActiveLanguage",
      preview: "designIframe/preview",
    }),
    theme() {
      return this.appearance.color.mode;
    },
    hideWidget() {
      return !this.shopSettings.isOpenCommerceWidget || (!this.shopSettings.isOpenCart && !this.shopSettings.isOpenCompareProduct && !this.shopSettings.isOpenWishlist);
    },
    cssVars() {
      return {
        '--wdgcom-bgclr': this.theme == 'light' ? '#ffffff' : '#000000',
        '--wdgcom-brdclr': this.theme == 'light' ? '#c2c2c2' : 'rgba(255, 255, 255, 0.81)',
        '--wdgcom-boxsh': '0 1px 1px rgba(0,0,0,0.05)',
        '--wdgcom-iconclr': this.theme == 'light' ? '#171717' : '#FFFFFF',
        '--wdgcom-iconclrhov': '#7c7c7c',
        '--wdgcom-textclr': '#7d7d7d',
      }
    }
  },
  methods: {
    toggleWidget() {
      this.isOpen = !this.isOpen;
    }
  },
};
</script>

<style lang="scss">
#widget-commerce {
  &.pointer-none {
    pointer-events: none;
  }
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 14px;
  z-index: 1;
  .menu-wrapper {
    background: var(--wdgcom-bgclr) !important;
    border: 1px solid var(--wdgcom-brdclr);
    box-shadow: var(--wdgcom-boxsh) !important;
    max-width: 80px;
    max-height: 90%;
    overflow-y: auto;
    font-family: 'Sarabun', 'Tahoma';
    min-width: 80px;
    transform: scale(1);
    transform-origin: right top;
    transition: transform .2s;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 0;
  }
  .wgdcom-item {
    text-decoration: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    &:hover {
      .wgdcom-icon {
        color: var(--wdgcom-iconclrhov);
      }
    }
  }
  .wgdcom-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--wdgcom-iconclr);
    position: relative;
    i, svg {
      font-size: 24px;
    }
  }
  .wgdcom-text {
    font-size: 14px;
    text-align: center;
    color: var(--wdgcom-textclr);
    display: flex;
    gap: 4px;
  }
  .wgdcom-btn {
    display: none;
  }
  @media only screen and (max-width: 1024px) {
    .menu-wrapper {
      position: absolute;
      right: 0;
      top: 50%;
      width: 100vw;
      height: auto;
      max-width: 400px;
      max-height: 90vh;
      transform: scale(0) translate3d(0, -50%, 0);
      -webkit-overflow-scrolling: touch;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      .wgdcom-item {
        width: 100%;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
        padding: 4px 16px;
      }
      &.is-open {
        transform: scale(1) translate3d(0, -50%, 0);
      }
      @media only screen and (max-width: 430px) {
        max-width: 90vw;
        min-width: 180px;
      }
    }
    .wgdcom-btn {
      display: flex !important;
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      height: 44px;
      width: 44px;
      background: var(--wdgcom-bgclr);
      border: 1px solid var(--wdgcom-brdclr);
      box-shadow: var(--wdgcom-boxsh);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: var(--wdgcom-iconclr);
      i, svg {
        font-size: 24px;
      }
      .icon-cart {
        display: block;
      }
      .icon-close {
        display: none;
      }
      &.theme-dark:hover {
        background: var(--wdgcom-iconclr);
        color: var(--wdgcom-bgclr);
      }
    }
    &.is-open {
      .wgdcom-btn {
        border: 2px solid transparent;
        box-shadow: unset;
        &.theme-dark:hover, &.theme-dark:focus {
          background: var(--wdgcom-iconclr);
          border: 2px solid var(--wdgcom-iconclr);
          color: var(--wdgcom-bgclr);
        }
        &.theme-light:hover, &.theme-light:focus {
          border: 2px solid var(--wdgcom-iconclr);
        }
        .icon-cart {
          display: none;
        }
        .icon-close {
          display: block;
        }
      }
    }
  }
}
</style>
